import { clearData } from "./clearData";

export async function addSynchinfo(thisSynchronizationInfo, synchFlag = false): Promise<void> {
    let synch = { synchronizationDate: new Date(), synchFlag }
    await clearData(thisSynchronizationInfo)
    await thisSynchronizationInfo.add(synch);
}
